import {
  Text,
  GreyGrey30,
  LayoutChromeLeading,
  StandardLayout,
  Flex
} from '@sequencehq/core-components'
import {
  REV_REC_ROUTES,
  REV_REC_ROUTES_LABELS
} from 'RevenueRecognition/revenueRecognition.router'
import { GreyGrey80, Primary14SemiBold } from '@sequencehq/core-components'
import { PageTitle } from '@sequencehq/core-components'

const Header = ({ children }: { children: React.ReactNode }) => {
  return (
    <Flex
      height="48px"
      paddingLeft="16px"
      paddingRight="16px"
      borderBottom="1px solid"
      borderColor={GreyGrey30}
      alignItems="center"
      gap="8px"
    >
      {/* The module has its own header bar rather than StandardLayout's, so it
          takes the nav toggle from the shared slot directly. */}
      <LayoutChromeLeading />
      <Flex flex="1" minWidth="0" height="100%" justifyContent="space-between">
        {children}
      </Flex>
    </Flex>
  )
}

const Breadcrumbs = ({
  route
}: {
  route: keyof typeof REV_REC_ROUTES_LABELS
}) => {
  const routeLabel = REV_REC_ROUTES_LABELS[route]
  const titleParts = routeLabel
    ? [routeLabel, 'Revenue recognition']
    : ['Revenue recognition']

  if (!routeLabel) {
    return (
      <>
        <PageTitle title={titleParts} />
        <Flex gap="4px" alignItems="center">
          <Text {...Primary14SemiBold} color={GreyGrey80}>
            Revenue recognition
          </Text>
        </Flex>
      </>
    )
  }

  return (
    <>
      <PageTitle title={titleParts} />
      <StandardLayout.Breadcrumbs>
        <StandardLayout.Breadcrumbs.Breadcrumb
          href={`/${REV_REC_ROUTES.basePath}/${REV_REC_ROUTES.overview}`}
        >
          Revenue recognition
        </StandardLayout.Breadcrumbs.Breadcrumb>
        <StandardLayout.Breadcrumbs.Breadcrumb>
          {routeLabel}
        </StandardLayout.Breadcrumbs.Breadcrumb>
      </StandardLayout.Breadcrumbs>
    </>
  )
}

export const RevRecHeader = Object.assign(Header, {
  Breadcrumbs
})
